// extracted by mini-css-extract-plugin
module.exports = {"container":"FirstLevel_container__2uBXh","lessonName":"FirstLevel_lessonName__AN32y","blocks":"FirstLevel_blocks__1u6ms","emptyList":"FirstLevel_emptyList__1ceoa"};